import { render, staticRenderFns } from "./AreaChartTy.vue?vue&type=template&id=42a46059&scoped=true"
import script from "./AreaChartTy.vue?vue&type=script&lang=js"
export * from "./AreaChartTy.vue?vue&type=script&lang=js"
import style0 from "./AreaChartTy.vue?vue&type=style&index=0&id=42a46059&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a46059",
  null
  
)

export default component.exports